const { curry } = require('ramda')
const { findWithId } = require('@mediatool/mt-utils/import')

function dispatcherGetCached (stream, id) {
  return findWithId(id, stream.extract())
}

module.exports = curry(dispatcherGetCached)
